import { render, staticRenderFns } from "./DividerHorizontal.vue?vue&type=template&id=42a1edc2"
var script = {}
import style0 from "./DividerHorizontal.vue?vue&type=style&index=0&id=42a1edc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports